document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
        var dur = 1200;
        var inicio = null;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / dur, 1);
          var valor = fin * (1 - Math.pow(1 - progreso, 3));
          el.textContent = (Number.isInteger(fin) ? Math.round(valor) : valor.toFixed(1)) + (el.getAttribute('data-mt-sufijo') || '');
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}
